import {Tabs} from 'antd';
import {AllVendors} from "./AllVendors";
import {NewVendorInput} from "./NewVendorInput";

export const ContactTab = ({refresh, onRefresh, onApiFail, props}) => {
    const items = [
        {
            key: 'Vendors',
            label: 'Vendors',
            children: <AllVendors refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'NewVendor',
            label: 'New',
            children: <NewVendorInput refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        }
    ];

    const onTabChange = () => {
    }

    const onClick = () => {
    }

    return <Tabs defaultActiveKey={'AllBuyers'} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}